import { ProfileState } from '.';
import { RootState } from '..';
import { useSelector } from 'react-redux';

export const useGetProfileState = (): ProfileState =>
  useSelector((state: RootState) => state.Profile);
